import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators';

export const getNameFromParams = (route: ActivatedRoute) => {
  return route.paramMap
    .pipe(
      map(params => params.get('name'))
    );
};
